<template>
  <a-modal :visible="visible" title="绑定关联地块vr" :footer="null" :afterClose="afterClose"
    @cancel="$emit('cancel')" :maskClosable="false">
    <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }" @submit="handleSubmit">
      <a-form-item label="选择地块">
        <a-select style="width: 120px" v-decorator="['value', { rules: [{ required: true, message: '请选择' }] }]">
          <a-select-option :value="option.vrId" v-for="option in options" :key="option.vrId">{{option.areaName}}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 12, offset: 5 }">
        <a-button type="primary" html-type="submit" style="margin-right: 20px;">确认</a-button>
        <a-button @click="toLandByVr" v-if="vrId">查看VR</a-button>
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    // 查询地块的级别
    areaLevel: {
      type: Number,
      default: 0
    },
    // 当前地块id
    areaId: {
      
    }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      options: [],
      vrId: '',
      areaName: ''
    }
  },
  computed: {
    
  },
  watch: {
    visible(n, o) {
      if(n) {
        this.getOptions()
      }
    }
  },
  methods: {
    // modal confirm
    initForm(value) {
      console.log('init', value)
      this.vrId = value.bindVrId
      this.areaName = value.areaName
      this.form.setFieldsValue({
        value: value.bindVrId
      })
    },
    getOptions() {
      if(!this.areaLevel || !this.areaId) return
      this.$api.unBindArea({
        areaLevel: this.areaLevel,
        areaId: this.areaId
      }).then(res => {
        if(res.content) {
          var options = res.content.filter(item => {
            return item.vrId
          })
          if(this.vrId) {
            options.unshift({
              vrId: this.vrId,
              areaName: this.areaName
            })
          }
          this.options = options
        }
      })
    },
    handleSubmit(e) {
      const self = this
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          var landItem = self.options.find(item => {
            return item.vrId === values.value
          })
          values.areaId = landItem.id
          values.areaLevel = landItem.areaLevel
          this.$emit('submit', values)
        }
      });
    },
    toLandByVr() {
      if(this.vrId) {
        this.$emit('to-land', this.vrId)
      }
    },
    afterClose() {
      this.vrId = ''
      this.form.resetFields()
    }
  }
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// ChooseLand.vue?88e3cbd8